import { Box, Stack, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import ClearIcon from "@mui/icons-material/Clear";
import Icon from "@mui/material/Icon";
import _ from "lodash";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../index";

const DEFAULT_TITLE = "Бонусная программа за расписание";

const DEFAULT_DESCRIPTION = `Мы доплачиваем вам за свободные окна в расписании

Просто за то, что окна есть и клиент их видит. Это сверх денег за выполненные заказы.
Главное правило: нужно набрать 6 часов за неделю и выполнить хотя бы один заказ.

Как их набрать - два шага:
Выберите 3 дня на неделе
В каждом дне отметьте 2 свободных часа

Сколько заплатим - зависит от времени:
- 🕐 Обычное время, будни с 14:00 до 18:00 → 180 ₽ за час
- ⭐ Дорогое время, будни с 18:00 до 20:00, а также суббота и воскресенье с 12:00 до 20:00 → 300 ₽ за час

Дорогое время - то, когда клиенты чаще всего ищут массаж. Поэтому за него платим почти вдвое больше.

Проще считать окнами
Окно - это 2 часа в один день:
- обычное окно (будни 14:00–18:00) → 360 ₽
- дорогое окно (будни 18:00–20:00 или выходные) → 600 ₽

Считаем:
- три обычных окна → 360+360+360 = 1080 ₽
- два обычных и одно дорогое → 360+360+600 = 1320 ₽
- одно обычное и два дорогих → 360+600+600 = 1560 ₽
- три дорогих окна → 600+600+600 = 1800 ₽

Например: понедельник, среда и пятница с 18:00 до 20:00 - три дорогих окна, 1800 ₽ за неделю.
Или: суббота 12:00–14:00, воскресенье 12:00–14:00 и вторник 18:00–20:00 - тоже три дорогих окна, 1800 ₽.

Правила - их шесть:
Часы отмечаем целые, без половинок
В одном дне считаем максимум 2 часа. Нам важно, чтобы окна были в разные дни - так клиенту есть из чего выбрать
Доплата считается максимум за 6 часов в неделю. Отмечать больше можно и нужно: сверх шести доплата не растёт, зато эти окна видят и бронируют клиенты - а это уже ваш прямой заработок.
Если отмечено больше 6 часов, в доплату идут самые дорогие из них - считаем в вашу пользу.
Меньше 6 часов за неделю - доплаты нет
Доплата начисляется за неделю без отмен с вашей стороны. Если запись отменил клиент - доплата сохраняется.

Если окно попадает и на обычное, и на дорогое время (например, 17:00–19:00), каждый час считается по своей ставке: 180 + 300 = 480 ₽.

Когда вносить: расписание на следующую неделю - до воскресенья 20:00. В течение недели можно добавлять новые окна, а убирать уже отмеченные - нет.
Коротко: 2 - 3 - 6. Два часа в окне, три окна, шесть часов. Всё в обычное время - 1080 ₽ за неделю, всё в дорогое - 1800 ₽
Когда придут деньги: доплата начисляется один раз за неделю - не за каждый заказ. Она приходит вместе с первым выполненным заказом этой недели. Со вторым и последующими заказами доплата не начисляется: она одна на неделю. Если за неделю не было ни одного выполненного заказа, доплата не начисляется.`;

const SPECIALIST_INFO_DEFAULT_STATE = {
  isLoaded: false,
  data: null,
};

const BonusProgramMassageSpecialist = ({ open, handleClose }) => {
  const { userId } = useContext(AuthContext);

  const [specialistInfo, setSpecialistInfo] = useState(
    SPECIALIST_INFO_DEFAULT_STATE,
  );

  async function loadSpecialist() {
    try {
      const resp = await axios.post(`/api/v1/specialists/get-specialists`, {
        userId,
      });

      setSpecialistInfo((prevState) => ({
        isLoaded: true,
        data: resp?.data,
      }));
    } catch (err) {
      // noop
    }
  }

  useEffect(() => {
    if (specialistInfo.isLoaded || !userId || !open) {
      return;
    }

    loadSpecialist();
  }, [specialistInfo.isLoaded, userId, open]);

  const program = _.head(specialistInfo?.data)?.bonusProgram;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      slotProps={{
          root: {},
          backdrop: {
              sx: {
                  backgroundColor: "rgba(0, 0, 0, 0.2)",
              },
          },
      }}
    >
        <Box
            sx={{
                maxWidth: "md",
                maxHeight: "80%",
                overflowY: "auto",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "#fff",
                padding: "30px",
                borderRadius: "20px",
                display: "flex",
                flexDirection: "column",
                "&:focus": {
                    outline: "none",
                }
            }}
        >
        <Icon
          onClick={handleClose}
          sx={{
            zIndex: 1306,
            p: "5px",
            backgroundColor: "#eee",
            borderRadius: "50%",
            position: "absolute",
            top: "10px",
            right: "10px",
          }}
        >
          <ClearIcon />
        </Icon>
        <Box
          sx={{
            display: "flex",
            flex: 1,
            backgroundColor: "#fff",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              overflowY: "auto",
              flex: 1,
              p: 2,
            }}
          >
            <Stack>
              <Typography sx={{ fontSize: "20px", pb: 3 }}>
                {program?.title ?? DEFAULT_TITLE}
              </Typography>
              <Box component={"span"} sx={{ whiteSpace: "pre-line" }}>
                <Typography sx={{ fontSize: "14px", lineHeight: 1.6 }}>
                  {program?.description ?? DEFAULT_DESCRIPTION}
                </Typography>
              </Box>
            </Stack>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default BonusProgramMassageSpecialist;
